<div
    class="fixed inset-0 sm:static max-h-screen sm:inset-auto flex flex-col sm:min-w-auto sm:w-auto sm:rounded-2xl overflow-y-auto overflow-hidden shadow-lg bg-white dark:bg-slate-900">
    <div class="w-full p-10 pb-0 flex justify-between">
        <span class="w-full text-black font-semibold text-2xl">Ver/Ocultar Columnas</span>
        <div class="absolute top-0 right-0 p-3">
            <button mat-icon-button (click)="onCloseMenu()">
                <mat-icon class="text-slate-400 text-2xl">close</mat-icon>
            </button>
        </div>
    </div>
    <!-- Alert -->
    <fuse-alert class="fixed top-0 left-0 w-full flex justify-center items-center mt-8 alert-main z-99999"
        [type]="_alertConfig.type" [appearance]="'outline'" *ngIf="showAlert" [@fadeIn]="showAlert">
        {{ _alertConfig.message }}
    </fuse-alert>
    <div class="p-10 grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4">
        <div *ngFor="let checkbox of mostrarCheckboxes" class="flex items-center">
            <mat-checkbox (change)="toggleCheckbox(checkbox)" [checked]="checkbox.checked === 1" color="primary">
                {{ checkbox.columnName }}
            </mat-checkbox>
        </div>
    </div>
    <div class="w-full md:flex md:justify-end md:pb-6 md:px-6 mt-auto">
        <button mat-raised-button class="w-full bg-primary rounded-none md:w-26 md:rounded-lg py-8 md:py-0"
            (click)="markAllCheckboxes()">
            <span class="text-white font-medium text-base">Ver Todas</span>
        </button>
    </div>
</div>